import { Injectable } from '@angular/core';

export interface RavenMessageOptions {
  level?: 'info' | 'warning' | 'error';
  logger?: string;  // my.module
  extra?: { [key: string]: any };
}

@Injectable()
export class RavenLoggerService {

  constructor() { }

  captureMessage(message: string, options?: RavenMessageOptions) {
    Raven.captureMessage(message, options);
  }

  captureBreadcrumb(message: string, data?: { [key: string]: any }) {
    Raven.captureBreadcrumb({ message, data });
  }
}



// WEBPACK FOOTER //
// ./src/app/core/raven/raven-logger.service.ts